import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-taluk-form',
  templateUrl: './taluk-form.component.html',
  styleUrls: ['./taluk-form.component.css']
})
export class TalukFormComponent implements OnInit {

  title = "Add Taluk";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/taluk/taluk-form/taluk-form.component.ts